<template>
    <!-- <PreloaderPage /> -->
    <div class="faq-page gap-general">
      <BannerPages
        :title="'faq.descriptform'"
        alt="Tradeview regulatory oversight"
        :showSearchComponent="true"
      />
      <div class="margin-general forex_tradeview" :style="degrade">
        <div class="forex_tradeview_text">
          <h2>{{ $t("faq.title-acco") }}</h2>
        </div>
    
        <LazyAccordeon :options="faqs" styleOption="var-one" :initialOpenTabs="false" render-closed-links />
      </div>
      <client-only>
        <LazyInvestment
          :label="'faq.investment'"
          :buttonConfigs="[
            {
              type: 'internal',
              to: '/contact-us/',
              class: 'primary-button-medium',
              textKey: 'faq.button'
            }
          ]"
        />
      </client-only>
    </div>
</template>
  
<script setup>
// import PreloaderPage from "~/components/PreloaderPage.vue";
import LazyAccordeon from "~/components/Accordeon";
import faqs from "~/assets/faqs.json"

import { useI18n } from "vue-i18n";
import { useImage } from '#imports';

const { t } = useI18n();
const nuxtImg = useImage();

const title = t("seo.faq.title");
const description = t("seo.faq.description");
const imgSeo = 'https://tradeview.eu/images/seo/35FAQ01.jpg'

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo
});

const degradadeImageUrl = '/images/faq/FAQ_Gradient.avif';

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: 'avif',
});


const degrade = computed(() => {
  return {
    '--degrade': `url('${optimizedDegrade}')`,
  };
});
</script>
